export default __webpack_public_path__ + "static/media/fee-white.425a9bb5.svg";